interface IProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
}

const CustomSwitch = (props: IProps) => {
    return <button className={props.disabled ? "switch disabled" : "switch"} tabIndex={6} onClick={() => props.onChange(!props.checked)} disabled={props.disabled}>
        <span className={props.disabled ? "un-checked" : props.checked ? "checked" : "un-checked"}>
            <span className={props.disabled ? "circle bg-color-primary-inactive" : "circle"}>
                {props.checked && <span></span>}
            </span>
        </span>
    </button>
}

export default CustomSwitch;